

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Meetingtype } from '../models/meetingtype';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class MeetingtypeService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'meetingtype/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllMeetingtype(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Meetingtype>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllMeetingtype?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewMeetingtype(MeetingType_Id?: string): Observable<Array<Meetingtype>> {
      return this.httpService.get(this.apiEndpoint + '/viewMeetingtype/' + (MeetingType_Id ? MeetingType_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveMeetingtype(Meetingtype: Meetingtype): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveMeetingtype/', Meetingtype).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteMeetingtype(MeetingType_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteMeetingtype/' + (MeetingType_Id ? MeetingType_Id : '00000000-0000-0000-0000-000000000000'), MeetingType_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(MeetingType_Id?: string,Code?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?MeetingType_Id=' + (MeetingType_Id ? MeetingType_Id : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
          return result; 
      }));
    }


  
  }

